import { IoMdMore } from "react-icons/io";
import { LuUser } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";

export default ({ item }: any) => {
  const navigate = useNavigate();
  const { setSelecteduser } = useStateSetter();

  return (
    <div
      onClick={() => {}}
      className="bg-whit shadow-sm border border-gray-200 rounded-[10px] flex  py-4  px-1 justify-between items-center"
    >
      <div className="flex">
        <LuUser
          size={45}
          className="bg-[#EAECF5] p-3 text-textbg ml-2 rounded-full "
        />
        <div className=" px-2">
          <p className="font-semibold text-xs cursor-pointer">
            {item.firstName} {item.lastName}
          </p>
         
          <p className="font-light text-xs cursor-pointer"> {item.email} </p>
          <div className="inline">
          <p className="font-light text-xs cursor-pointer inline">
            <GoDotFill className="inline text-green-600" /> Active
          </p>

          <p className="text-xs bg-faintBlue inline rounded p-1  ">{item.userType}</p>
          </div>
         
        </div>
      </div>

      <IoMdMore size={20} className="text-textbg " />
    </div>
  );
};
 